import { reactive, readonly, toRefs } from 'vue';

const state = reactive({
  globalMessage: ''
});

export const globalMessage = readonly(toRefs(state).globalMessage);

export function setGlobalMessage(message = '') {
  state.globalMessage = message;
}
